import { createAction, props } from '@ngrx/store';
import {
  GetPaymentInformationResponseDto,
  UpdatePaymentInformationBillingAddressRequestDto,
} from '../../interfaces/settings/payment-information.interface';

export const loadPayment = createAction('[Payment/API] Load Payment');

export const loadPaymentSuccess = createAction(
  '[Payment/API] Load Payment Success',
  props<{ paymentInformation: GetPaymentInformationResponseDto }>()
);

export const loadPaymentFailure = createAction('[Payment/API] Load Payment Failure', props<{ error: any }>());

export const updateBillingAddress = createAction(
  '[Payment/API] Update Billing Address',
  props<{ billingAddress: UpdatePaymentInformationBillingAddressRequestDto }>()
);

export const updateBillingAddressSuccess = createAction(
  '[Payment/API] Update Payment Success',
  props<{ billingAddress: UpdatePaymentInformationBillingAddressRequestDto }>()
);

export const updateBillingAddressFailure = createAction(
  '[Payment/API] Update Payment Failure',
  props<{ error: any }>()
);

export const setBankTransfer = createAction('[Payment/API] Update Payment method to Bank Transfer');

export const setBankTransferSuccess = createAction('[Payment/API] Update Payment method to Bank Transfer Success');

export const setBankTransferFailure = createAction(
  '[Payment/API] Update Payment method to Bank Transfer Failure',
  props<{ error: any }>()
);

export const clearPayment = createAction('[Payment/API] Clear Payment');
